module.exports = __webpack_public_path__ + "static/img/59-1.1674386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/59-1.jpg
// module id = V9G/
// module chunks = 0